export default ({ min, max }: FixmeType) =>
    ({}) => {
        return {
            yAxis: {
                min,
                max,
            },
        };
    };
